module.exports = __webpack_public_path__ + "e4f8a6371e304a8add6b4bede5d1824a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/round-s.png
// module id = 1213
// module chunks = 0